import { render, staticRenderFns } from "./App.vue?vue&type=template&id=b8edb006&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=b8edb006&prod&scoped=true&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&id=b8edb006&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8edb006",
  null
  
)

export default component.exports